const Environment = {
    apiUrl: process.env.REACT_APP_API_URL || "http://localhost:5000/graphql",
    wsUrl: process.env.REACT_APP_API_WEBSOCKET || "ws://localhost:5000/graphql",
  REACT_APP_EMAILJS_RECEIVER: process.env.REACT_APP_EMAILJS_RECEIVER,
  REACT_APP_EMAILJS_TEMPLATEID: process.env.REACT_APP_EMAILJS_TEMPLATEID,
  REACT_APP_EMAILJS_USERID: process.env.REACT_APP_EMAILJS_USERID,
  VERSION_SOFTWARE: process.env.VERSION_SOFTWARE
}
export default Environment;
